module.exports = {"420502001":"西陵街道","420502002":"学院街道","420502003":"云集街道","420502004":"西坝街道","420502005":"葛洲坝街道","420502006":"夜明珠街道","420502007":"东苑街道","420502008":"南苑街道","420502009":"北苑街道","420502010":"窑湾街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420502.json
// module id = 1725
// module chunks = 0